<template>
    <b-modal
        v-model="modal"
        :id="'school-access-connect-modal'"
        :ref="'school-access-connect-modal'"
        :title="$t('school.link_teacher')"
        :ok-title="$t('common.close')"
        ok-only
        size="lg"
        modal-class="apprentice-default-modal">
        <b-tabs
            class="school-access-management-tab apprentice-tab"
            content-class="school-access-management-tab-content">
            <b-tab
                :title="$t('common.add')"
                active>
                <design-2021-apprentice-data-table
                    :items="teachers"
                    :fields="fields">
                    <template v-slot:cell(actions)="data">
                        <b-button
                            class="btn-chain-link"
                            variant="primary-icon-only"
                            @click="onConnect(data.item)"></b-button>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>
            <b-tab :title="$t('common.delete')">
                <design-2021-apprentice-data-table
                    :items="currentTeachers"
                    :fields="fields">
                    <template v-slot:cell(actions)="data">
                        <b-button
                            class="btn-remove"
                            variant="danger-icon-only"
                            @click="onRemove(data.item)"></b-button>
                    </template>
                </design-2021-apprentice-data-table>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-school-access-connect-modal-component',
    data() {
        return {
            modal: false,
            itemTitle: null,
            item: null,
            teachers: [],
            currentTeachers: [],
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('school.name_teacher'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        show(title, item, teachers, currentTeachers) {
            this.item = item;
            this.title = title;
            this.teachers = teachers;
            this.currentTeachers = currentTeachers;

            this.modal = true;
        },
        onConnect(teacher) {
            const data = {
                teacher: teacher,
                item_id: this.item.id,
            };
            this.$emit('connect-item', data);
        },
        onRemove(teacher) {
            const data = {
                teacher_id: teacher.id,
                item_id: this.item.id,
            };
            this.$emit('remove-item', data);
        },
    },
};
</script>

<style scoped></style>
